import { PayPalButtons } from '@paypal/react-paypal-js';
import { Button } from '../ui/Button';
import { api } from '../../api/client';

interface PayPalButtonProps {
  amount: number;
  currency: string;
  invoiceId: number;
  onSuccess: () => void;
  onError: (error: string) => void;
  onCancel: () => void;
}

export function PayPalButton({
  amount,
  currency,
  invoiceId,
  onSuccess,
  onError,
  onCancel,
}: PayPalButtonProps) {
  // Create PayPal order by calling our backend
  const createOrder = async () => {
    try {
      const response = await api.post('/payment/process', {
        invoiceId,
        amount,
        gateway: 'paypal',
        paymentMethod: 'paypal',
      });

      if (!response.orderId) {
        throw new Error('Failed to create PayPal order');
      }

      return response.orderId;
    } catch (error: any) {
      onError(error.message || 'Failed to create PayPal order');
      throw error;
    }
  };

  // Capture payment after approval
  const onApprove = async (data: any) => {
    try {
      // Call backend to capture the payment
      const response = await api.post('/payment/paypal/capture', {
        orderId: data.orderID,
        invoiceId,
      });

      if (response.success) {
        onSuccess();
      } else {
        onError('Payment capture failed');
      }
    } catch (error: any) {
      onError(error.message || 'Payment capture failed');
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-slate-800/80 border border-slate-700/50 rounded-lg p-6">
        <PayPalButtons
          style={{
            layout: 'vertical',
            color: 'gold',
            shape: 'rect',
            label: 'paypal',
          }}
          createOrder={createOrder}
          onApprove={onApprove}
          onCancel={() => {
            onCancel();
          }}
          onError={(err) => {
            console.error('PayPal Error:', err);
            onError('PayPal payment failed. Please try again.');
          }}
        />
        <div className="bg-blue-900/20 border border-blue-700 rounded p-3 text-sm text-blue-300 mt-4">
          🔒 You will be redirected to PayPal to complete your payment securely
        </div>
      </div>

      <div className="flex">
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          className="flex-1"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
